import { escape as lodashEscape, unescape } from 'lodash';

import { BLACKLIST_TEXT_REGEX } from 'bundles/cml/shared/constants';

/**
 * Escapes a string for safe embedding in CML/XML.
 * - Strips control characters that are illegal in XML 1.0 (e.g. form feed \x0C)
 * - Encodes standard HTML entities via Lodash (&, <, >, ", ')
 */
export const escape = (s: string): string => {
  const sanitized = s.replace(BLACKLIST_TEXT_REGEX, '');
  return lodashEscape(sanitized);
};

/**
 * Unescapes a CML/XML-escaped string back to plain text.
 */
export { unescape };
